import { apiSlice } from './apiSlice';
export const locationsApi = apiSlice.injectEndpoints({ endpoints: builder => ({
  getCountries: builder.query({ query: () => '/api/locations/countries', keepUnusedDataFor: 3600 }),
  getCities: builder.query({ query: code => `/api/locations/cities/${encodeURIComponent(code)}`, keepUnusedDataFor: 3600 }),
}) });
export const { useGetCountriesQuery, useGetCitiesQuery } = locationsApi;
